import { render } from "./SalesTrendReport.vue?vue&type=template&id=f3e41e8c&scoped=true"
import script from "./SalesTrendReport.vue?vue&type=script&lang=js"
export * from "./SalesTrendReport.vue?vue&type=script&lang=js"

import "../inventory/inventoryReport.css?vue&type=style&index=0&id=f3e41e8c&scoped=true&lang=css&external"
import "./SalesTrendReport.vue?vue&type=style&index=1&id=f3e41e8c&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f3e41e8c"]])

export default __exports__